import * as batshit from "@yornaath/batshit";
import {AssessmentId, nominate, Risk, RiskContextId, RiskId, RiskIdPair} from "../../../Types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";
import {resolver, resolverFn, scheduler} from "../../batch";

function encodeIdPair(idPair: RiskIdPair): string {
  return `${idPair.assessment_id}/${idPair.risk_id}`;
}
function decodeIdPair(value: string): RiskIdPair {
  const [assessmentId, controlId] = value.split("/", 2);
  return {assessment_id: nominate("assessmentId", assessmentId), risk_id: nominate("riskId", controlId)};
}

const risks = batshit.create({
  fetcher: (queries: string[]) => api.tprm.risks.load(queries.map(decodeIdPair)),
  resolver: resolverFn((risk: Risk, idPair: string) => risk.risk_id === decodeIdPair(idPair).risk_id),
  scheduler,
});

const riskContexts = batshit.create({
  fetcher: api.tprm.risks.loadContexts,
  resolver: resolver("risk_context_id"),
  scheduler,
});

export const risk = typedQuery(
  ["tprm", "risk", param<AssessmentId>("assessmentId"), param<RiskId>("riskId")],
  async (assessmentId, riskId) => {
    return await risks.fetch(encodeIdPair({assessment_id: assessmentId, risk_id: riskId}));
  },
);

export const riskContext = typedQuery(
  ["tprm", "riskContext", param<RiskContextId>("riskContextId")],
  async riskContextId => {
    return await riskContexts.fetch(riskContextId);
  },
);
